export var domainDefault = process.env.REACT_APP_API_URL || 'https://smartcfo.ca/api/v1';
